import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import jsQR from 'jsqr';
export default {
  props: {
    continue: {
      type: Boolean,
      default: true // false 监听一次   true 持续监听
    },
    exact: {
      type: String,
      default: 'environment' // environment 后摄像头  user 前摄像头
    },
    size: {
      type: String,
      default: 'whole' // whole 全屏  balf 半屏
    },
    definition: {
      type: Boolean,
      default: false // fasle 正常  true 高清
    }
  },
  data() {
    return {
      windowWidth: 0,
      windowHeight: 0,
      video: null,
      canvas2d: null,
      canvas2d2: null,
      canvasWidth: 200,
      canvasHeight: 200,
      maskWidth: 0,
      maskHeight: 0,
      inter: 0,
      track: null,
      isUseTorch: false,
      trackStatus: false,
      isParse: false,
      isUse: true
    };
  },
  created() {
    if (origin.indexOf('https') === -1) throw '请在 https 环境中使用摄像头组件。';
    this.windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
    this.windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    this.windowHeight = this.size === 'whole' ? this.windowHeight : this.windowHeight / 2;
    this.isParse = true;
    this.$nextTick(() => {
      this.createMsk();
      this.openScan();
    });
  },
  unmounted() {
    this.closeCamera();
  },
  methods: {
    openScan() {
      const width = this.transtion(this.windowHeight);
      const height = this.transtion(this.windowWidth);
      const videoParam = {
        audio: false,
        video: {
          facingMode: {
            exact: this.exact
          },
          width,
          height
        }
      };
      navigator.mediaDevices.getUserMedia(videoParam).then(stream => {
        this.video = document.createElement('video');
        this.video.width = this.windowWidth;
        this.video.height = this.windowHeight;
        const canvas = document.createElement('canvas');
        canvas.id = 'canvas';
        canvas.width = this.transtion(this.canvasWidth);
        canvas.height = this.transtion(this.canvasHeight);
        canvas.style = 'display:none;';
        //canvas.style = 'position: fixed;top: 0;z-index: 999;left:0'
        this.canvas2d = canvas.getContext('2d');

        // 设置当前宽高 满屏
        const canvasBox = document.querySelector('.canvasBox');
        canvasBox.append(this.video);
        canvasBox.append(canvas);
        canvasBox.style = `width:${this.windowWidth}px;height:${this.windowHeight}px;`;

        // 创建第二个canvas
        const canvas2 = document.createElement('canvas');
        canvas2.id = 'canvas2';
        canvas2.width = this.canvasWidth;
        canvas2.height = this.canvasHeight;
        canvas2.style = 'position: absolute;top: 50%;left: 50%;z-index: 20;transform: translate(-50%, -50%);';
        this.canvas2d2 = canvas2.getContext('2d');
        canvasBox.append(canvas2);
        this.video.srcObject = stream;
        this.video.setAttribute('playsinline', true);
        this.video.play();
        this.tick();
        this.track = stream.getVideoTracks()[0];
        setTimeout(() => {
          this.isUseTorch = this.track.getCapabilities().torch || null;
        }, 500);
      }).catch(err => {
        this.isUse = false;
        this.$emit('error', err);
      });
    },
    closeCamera() {
      this.isParse = false;
      if (this.video && this.video.srcObject) {
        this.video.srcObject.getTracks().forEach(track => {
          track.stop();
        });
      }
    },
    tick() {
      if (!this.isParse) return;
      if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
        this.canvas2d.drawImage(this.video, this.transtion(this.maskWidth), this.transtion(this.maskHeight), this.transtion(200), this.transtion(200), 0, 0, this.transtion(this.canvasWidth), this.transtion(this.canvasHeight));
        const imageData = this.canvas2d.getImageData(0, 0, this.transtion(this.canvasWidth), this.transtion(this.canvasHeight));
        const code = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: 'dontInvert'
        });
        this.canvas2d2.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        if (code) {
          this.drawLine(code.location.topLeftCorner, code.location.topRightCorner);
          this.drawLine(code.location.topRightCorner, code.location.bottomRightCorner);
          this.drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner);
          this.drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner);
          if (code.data) {
            this.getData(code.data);
          }
        }
      }
      requestAnimationFrame(this.tick);
    },
    drawLine(begin, end, color = '#FF3B58') {
      this.canvas2d2.beginPath();
      this.canvas2d2.moveTo(this.nutranstion(begin.x), this.nutranstion(begin.y));
      this.canvas2d2.lineTo(this.nutranstion(end.x), this.nutranstion(end.y));
      this.canvas2d2.lineWidth = 4;
      this.canvas2d2.strokeStyle = color;
      this.canvas2d2.stroke();
    },
    getData(data) {
      this.$emit('success', data);
      if (!this.continue) {
        this.closeCamera();
      }
    },
    openTrack() {
      var _this$track;
      this.trackStatus = !this.trackStatus;
      (_this$track = this.track) === null || _this$track === void 0 || _this$track.applyConstraints({
        advanced: [{
          torch: this.trackStatus
        }]
      });
    },
    createMsk() {
      this.maskWidth = this.windowWidth / 2 - this.canvasWidth / 2;
      this.maskHeight = this.windowHeight / 2 - this.canvasHeight / 2;
    },
    transtion(number) {
      return this.definition ? number * 2.8 : number * 1.8;
    },
    nutranstion(number) {
      return this.definition ? number / 2.8 : number / 1.8;
    }
  }
};